/*
    模块组件
    ChenYN

    说明
    发现页/每日福利

    版本
    1.0

    传参
        name Sting : 当前页面的name(同路由)
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <SignWelfare></SignWelfare>
*/
<template>
    <div class="sign_welfare">
        <div class="scroll_wrapper">
            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>

            <!-- S 签到 -->
            <div class="sign_wrap">
                <div class="tit_bar">
                    <div class="bar_item">
                        <img class="icon" :src="icons['3']" alt="金币">
                        <span>x{{integral}}</span>
                    </div>
                    <div class="bar_item">
                        <img class="icon" :src="icons['4']" alt="补签券">
                        <span>x{{reissue_card}}</span>
                    </div>
                    <div class="bar_item">
                        <img class="icon" :src="icons['50']" alt="宝箱">
                        <span>x{{box}}</span>
                    </div>

                    <div class="rule" @click="showPop">规则弹窗</div>
                </div>

                <div class="sign_list">
                    <div class="sign_item" :style="mcGameShow?{'min-width':'66px'}:''" :class="{sign_finish : v.status == 1}" v-for="(v,i) in detail" :key="i" @click="sign(1)">
                        <div class="tit">{{v.name || ''}}</div>
                        <div class="prize" v-if="i != (detail.length - 1)">
                            <img class="icon" :src="icons['3']" alt="">
                            <span>+{{v.integral}}</span>
                        </div>
                        <div class="box_img" v-else>
                            <img :src="boxImage" alt="">
                        </div>

                        <div class="btn_wrap" v-if="v.show_button == 1">
                            <Button v-if="v.status == 0" class="sign_btn" round>签到</Button>
                            <Button v-else  class="sign_btn" round>补签</Button>
                        </div>
                        <div v-else-if="v.status == 1" class="finish_btn" round>
                            <img src="@/assets/images/find/icon_sign_finish.png" alt="">
                        </div>
                        <div v-else class="occupy_btn"></div>

                    </div>
                </div>

            </div>
            <!-- E 签到 -->

            <!-- S 每日宝箱 -->
            <div class="day_box">
                <div class="title title_flex">
                    <div>每日宝箱</div>
                    <div class="box_detail" @click="showGood">奖品一览<img :src="findIcon"/></div>
                </div>
                <div class="box_wrap">
                    <div class="box">
                        <img :src="icons['50']" alt="">
                    </div>
                    <div class="info">
                        <div class="num">剩余免费开启<span>{{box || 0}}</span>次</div>
                        <Button @click="openBox" class="draw_btn" :class="{ unbtn: boxDetail.activity_info && boxDetail.activity_info.status == 0 }" round>{{ boxDetail.activity_info ? screen(boxDetail.activity_info, box) : '' }}</Button>
                    </div>
                </div>
            </div>
            <!-- E 每日宝箱 -->

            <!-- S 积分商城 -->
            <div class="integral_wrap">
                <div class="title">积分商城</div>

                <div class="goods_list">
                    <div class="goods_item" @click="goState({name: 'goodsdetail', params: {goodsid: v.item_id}})" v-for="v in shopList" :key="v.item_id">
                        <shop-card :goodsData="v"></shop-card>
                    </div>
                </div>
            </div>
            <!-- E 积分商城 -->

        </div>
    </div>

    <!-- S 打开每日盒子结果弹窗 -->
    <Popup v-model:show="showPrizePop" teleport="#app" class="prize_popup">
        <div class="prize_pop">
            <Icon class="close_btn" name="cross" @click="closePrizePop" />
            <div class="prize_img">
                <img v-if="prize.img" :src="prize.img" :alt="prize.name">
            </div>
            <div class="prize_name van-multi-ellipsis--l3">{{prize.name}}</div>
        </div>
        <div class="prize_box_img">
            <img src="@/assets/images/find/icon_box_open.png" alt="">
        </div>
    </Popup>
    <!-- E 打开每日盒子结果弹窗 -->

    <!-- S 签到/补签结果弹窗 -->
    <Popup v-model:show="showSignPop" teleport="#app" class="prize_popup">
        <div class="sign_pop">
            <Icon class="close_btn" name="cross" @click="closeSignPop" />
            <div class="tip_title">
                <img src="@/assets/images/sign/icon_complete.png" alt="">
                <span>{{signPrize.title}}</span>
            </div>
            <div class="sub_tit">获得奖励</div>
            <div class="sign_prize">
                <div class="prize_item" v-for="(v,i) in signPrize.prize" :key="i">
                    <img :src="v.img" alt="">
                    <span>+{{v.tit}}</span>
                </div>
            </div>

        </div>
    </Popup>
    <!-- E 签到/补签结果弹窗 -->

    <!-- S 签到/补签结果弹窗 -->
    <Popup v-model:show="showTipsPop" teleport="#app" class="prize_popup">
        <div class="sign_pop tips_pop">
            <Icon class="close_btn" name="cross" @click="showTipsPop = false" />
            <div class="title">提示</div>
            <div class="txt">确定要花费【补签券*1】进行补签吗？</div>
            <div class="btns_wrap">
                <Button class="btn cancel" @click="showTipsPop = false" >取消</Button>
                <Button class="btn" @click="sign(2)">确定</Button>
            </div>
        </div>
    </Popup>
    <!-- E 签到/补签结果弹窗 -->

    <!-- S 奖品一览弹窗 -->
    <Popup v-model:show="showGoodPop" teleport="#app" class="prize_popup">
        <div class="goods_pop">
            <div class="title"><div>奖品一览</div><img src="@/assets/images/find/icon_close.png" alt="" @click="closeGood"></div>
            <div class="content_wrap">
                <div class="content">
                    <div class="good_item" v-for="(v,i) in treasure" :key="i">
                        <GoodCard :goodData='v'></GoodCard>
                    </div>
                </div>
            </div>
        </div>
    </Popup>
    <!-- E 奖品一览弹窗 -->


    <rule-popup :show="showRule" :rule="rule" :close="closeRulePop"></rule-popup>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onActivated, onDeactivated , computed } from 'vue';
import { Button, ImagePreview, Loading, Popup, Icon  } from "vant"
import router from "@/router"
import store from "@/store"
import Util from '@/assets/js/lib/util';
import BScroll from '@better-scroll/core'
import Pulldown from '@better-scroll/pull-down'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import RulePopup from '@/components/Seven_RulePopup/RulePopup.vue';
import ShopCard from '@/components/Seven_ShopCard/ShopCard.vue';
import GoodCard from '@/components/Seven_GoodCard/GoodCard.vue';
import findIcon from '@/assets/images/find/icon_find.png';


export default defineComponent({
    name: 'SignWelfare',
    components: { Button, ImagePreview, Loading, RulePopup, Popup, Icon, ShopCard, GoodCard},
    props: {
        name: {
            type: String,
            default: 'index'
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
            icons: computed(() => store.state.icons),
            userInfo: computed(() => store.state.userInfo),
            bs: '',
            mcGameShow:false,
            isRefreshing: false, //是否正在刷新中
            refreshTxt: '下拉刷新', //下拉刷新提示文字
            showRule: false, //是否显示规则弹窗
            showPrizePop: false, //是否显示开宝箱后弹窗
            prize:{img: '', name: ''}, //开宝箱弹窗里的数据
            openBoxFlag: false, //打开盒子的控制器,避免多次点击
            showSignPop: false, //是否显示签到弹窗
            signPrize: {
                title: '签到成功',
                prize: [
                    {
                        img: 'https://9377gamebox.oss-cn-beijing.aliyuncs.com/9377ZS_item_default_3.png',
                        tit: '10000'
                    },
                ]
            },
            showTipsPop: false, //是否显示提示弹窗
            findIcon: findIcon, //搜索icon
            showGoodPop: false,//是否展示奖品一览
            allGoodsBs: '', //全部奖品一览的滚动条
        });
        const data = reactive({
            box: 0, //宝箱数量
            integral: 0, //用户积分
            reissue_card: 0, //补签券
            detail: [], //签到详情
            boxImage: '', //第七天签到的宝箱图片
            rule: { //规则数据
                title: '',
                content: '',
            },
            boxDetail: {}, //每日宝箱详情
            shopList: [],
            treasure: [],//奖品一览数据
        });
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            swipeChange: (e) => state.currentPageIndex = e,
            viewSwipe: (index = 0) => {
                ImagePreview({
                    startPosition: index,
                    images: computed(() => { let arr = []; data.bannerList.map(v => arr.push(v.url)); return arr;}),
                    closeable: true,
                });
            },
            sign: (type = 0) => { //签到，目前没有做太多规则
                // if(type == 1){ //补签
                //     if(data.reissue_card <= 0){
                //         window.Components.toast('补签券不足~');
                //         return false;
                //     };

                //     state.signPrize.title = '补签成功';
                //     state.showTipsPop = true;
                // }else if(type == 2) { //签到
                //     state.showTipsPop = false;
                //     reqSign();
                // }else {
                //     state.signPrize.title = '签到成功';
                    reqSign();
                // };
            },
            closeRulePop: () => state.showRule = false, //关闭规则弹窗
            showPop: async() => { //显示规则弹窗
                const res = await state.util.getJson( "/common/information", "GET", {type: 3}, true );
                if (res.code == 1) {
                    data.rule = res.data;
                    state.showRule = true;
                } else {
                    window.Components.toast(res.msg);
                }
            },
            screen: (obj, num) => { //筛选按钮状态
                if (obj.status == 0) {
                    return "活动还未开始";
                } else if (num > 0) {
                    return "免费开启宝箱";
                } else {
                    return obj.integral + "积分开启";
                }
            },
            closePrizePop: () => {
                state.showPrizePop = false;
            },
            openBox: () => {
                if(state.openBoxFlag) return false;
                state.openBoxFlag = true;
                state.prize = {img: '', name: ''};
                reqOpenDayBox();
            },
            closeSignPop: () => {
                state.showSignPop = false;
            },
            showGood: () => {
                state.showGoodPop = true;
                setTimeout(() => {
                    initAllGoodsScroll();
                    state.allGoodsBs.refresh();
                }, 100);
            },
            closeGood: () => {
                state.showGoodPop = false;
                setTimeout(() => {
                    state.allGoodsBs.scrollTo(0, 0);
                    state.allGoodsBs.destroy();
                }, 100);
            }
        }; //需要对外暴露的方法

        const initAllGoodsScroll = () => { //打开全部奖品一览
            state.allGoodsBs = new BScroll('.content_wrap',{
                scrollY: true,
                click: true,
                probeType: 1,
                bounceTime: 400,
                outOfBoundaryDampingFactor: 0.2,
                specifiedIndexAsContent: 0,
                bindToWrapper: true,
                stopPropagation: true
            });
        };

        onMounted(async () => {
              /* S pc微端的时候 判断 改样式*/
              const str = window.external&&window.external.getClientProName&&window.external.getClientProName()
              if(str == "McGame"){
                state.mcGameShow = true
              }
            /* E pc微端的时候 判断 改样式*/
            if (new Util().Cookie().get("access_token")) {
                await reqGameData();
                await reqDayBox();
                await reqShopList();

                initScroll();
            }
        });

        onActivated(async () => {
            if (new Util().Cookie().get("access_token")) {
                await reqGameData();
                await reqDayBox();
                await reqShopList();
                state.openBoxFlag = false;
                if(state.bs == ''){
                    initScroll();
                }
            }
        })

        onDeactivated(() => {
            window.Components.toast.clear();
        })

        const initScroll = () => { //初始化上下滚动
            state.bs = new BScroll('.sign_welfare',{
                scrollY: true,
                click: true,
                probeType: 2,
                bounceTime: 400,
                swipeBounceTime: 400,
                outOfBoundaryDampingFactor: 0.6,
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                deceleration: 0.009,
                observeImage: true
            })

            state.bs.on('scroll',  (position) => {
                if(position.y < 38){
                    state.refreshTxt = '下拉刷新';
                    state.isRefreshing = false;
                    state.bs.finishPullDown();
                }else {
                    state.refreshTxt = '释放刷新'
                }
            });

            state.bs.on('pullingDown', async () => {

                state.isRefreshing = true;
                state.page = 1;
                state.total = 1;

                await reqGameData();
                await reqDayBox();

                setTimeout(() => {
                    window.Components.toast('刷新成功');
                    state.bs.finishPullDown();
                    state.bs.refresh();
                }, 300);
            });

            setTimeout(() => {
                state.bs.refresh();
            }, 100);
        };

        const reqGameData = async () => { //页面数据
            const res = await state.util.getJson('/signIn', 'GET', {}, true);
            if(res.code == 1){
                data.detail = res.data.detail;
                data.box = res.data.box.value;
                data.integral = res.data.integral.value;
                data.reissue_card = res.data.reissue_card.value;
                data.boxImage = res.data.sign_background
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqDayBox = async() => { //请求每日宝箱详情
            const res = await state.util.getJson('/treasure', 'GET', {}, true);

            if(res.code == 1){
                data.boxDetail = res.data
                data.treasure = res.data.treasure
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqOpenDayBox = async() => { //打开宝箱

            window.Components.toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })

            const res = await state.util.getJson('/treasure/open', 'POST', {}, true);
            state.openBoxFlag = false;
            window.Components.toast.clear();
            if(res.code == 1){

                state.showPrizePop = true;
                state.prize.img = res.data.image;
                state.prize.name = res.data.remark;
                state.util.refreshUserInfo(); //刷新用户信息
                await reqGameData();
                await reqDayBox();
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqShopList = async() => { //请求商品列表

            const res = await state.util.getJson('/mall', 'GET', {}, true);

            if(res.code == 1){
                data.shopList = res.data.goods;
            }else {
                window.Components.toast(res.msg)
            }
        };

        //点击签到
        const reqSign = async () => { //签到
            const res = await state.util.getJson( "/signIn/add", "POST", {}, true );
            if (res.code == 1) {
                let result = await state.util.refreshUserInfo();
                if (result.code !== 1) {
                    state.util.login()
                }
                data.detail = res.data.detail;
                data.box = res.data.box.value;
                data.integral = res.data.integral.value;
                data.reissue_card = res.data.reissue_card.value;

                state.signPrize.prize = [
                    {
                        tit: res.data.increase_integral,
                        img: state.icons['3']
                    },
                    {
                        tit: res.data.increase_box,
                        img: state.icons['50']
                    }
                ];

                state.showSignPop = true;

                state.util.refreshUserInfo(); //刷新用户信息
            } else {
                window.Components.toast(res.msg);
            }
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods,
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "./SignWelfare.less";
</style>
